<div class="card">
  <div class="card-header text-header">
    <div>{{ templateName }}</div>
  </div>
  <app-progress-bar [isLoading]="isLoadingMain"></app-progress-bar>
  <div class="p-2">
    <div class="card-body">
      <div class="tab-content p-1">
        <div class="overflow-x reporting_table">
          <p-table [value]="rows" [columns]="headers" [scrollable]="true" scrollHeight="400px" class="reporting_template_table">
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th *ngFor="let col of columns"  [innerHTML]="col | linebreak"></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body">
              <tr *ngFor="let row of structuredData; let j = index">
                <ng-container *ngFor="let cell of row | keyvalue; let i = index">
                  <td *ngIf="cell.key !== 'RulebookId'; else skipCell"
                      [ngClass]="cell.value == null ? 'highlight' : 'nonhighlighted'" (dblclick)="openView(row.RulebookId,2)">
                      <ng-container *ngIf="i !== 2">
                        {{ cell.value }}
                      </ng-container>
                      <ng-container *ngIf="i === 2">
                        <a (click)="getTooltipData(row.RulebookId)">
                          {{ cell.value }}
                        </a>
                          <span #tooltipTrigger [id]="row.RulebookId" tooltipEvent="focus" [pTooltip]="tooltipText" tooltipPosition="right" [style.display]="'block'"></span>
                      </ng-container>
                  </td>
                  <ng-template #skipCell></ng-template>
                </ng-container>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  </div>
</div>
